export const EMPTY_STATE_LAYOUT_CLASS_NAME =
  "bg-background-2 dark:bg-secondary h-full min-h-0 w-full flex-1";

export const EMPTY_STATE_SURFACE_CLASS_NAME = `${EMPTY_STATE_LAYOUT_CLASS_NAME} border-border rounded-lg border`;
